import React, { useState, useEffect, useContext, useRef } from "react";

import { Row, Col, Image, Modal } from "react-bootstrap";
import TabsLucrare from "../tabs_lucrare/TabsLucrare";
import {
  deleteDomeniuDocument,
  getDomeniuDocumentFileNames,
  uploadDomeniuDocument,
} from "../backend/FileUploadService";
import { useLocation, useNavigate } from "react-router-dom";
import { RefreshContext } from "../context/RefreshContext";
import logo_image from "../imgs/logo.png";
import ConfirmActionComponent from "./basic/ConfirmActionComponent";
import ModalComponent from "./basic/ModalComponent";
import fileCreateIcon from "../imgs/file-create-icon.png"
import ModalFolderDomeniuCreate from "./ModalFolderDomeniuCreate";
import DocumentDomeniuItem from "./DocumentDomeniuItem";

const DocumenteDomeniuViewer = () => {
  const [documentsNames, setDocumentsNames] = useState([]);
  const [triggerLucrari, setTriggerLucrari] = useState(false);
  const [activeTab, setActiveTab] = useState("locatie");
  const location = useLocation();
  const {
    internet,
    serverError,
    triggerFisiereDomeniu,
    refreshFisiereDomeniu,
  } = useContext(RefreshContext);
  const [responseReceived, setResponseReceived] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState();
  const [error, setError] = useState();
  const hiddenDocumentInput = useRef(null);
  const [showModalFolderDomeniuCreate, setShowModalFolderDomeniuCreate] =
    useState(false);
  const navigate = useNavigate();

  //prop trimise prin history.push
  const { locationType, currentLucrare, folderName } = location.state;
  const setTab = (value) => {
    setActiveTab(value);
  };

  const refreshLucrari = () => {
    setTriggerLucrari(!triggerLucrari);
  };

  const chooseDocumentToUpload = (e) => {
    hiddenDocumentInput.current?.click();
  };

  const getDocumentNames = async () => {
    try {
      const result = await getDomeniuDocumentFileNames(
        locationType.toLowerCase(),
        folderName
      );
      setDocumentsNames(result);
      setResponseReceived(true);
    } catch (err) {
      setError("Eroare la preluarea documentelor", err);
    }
  };

  useEffect(() => {
    getDocumentNames();
  }, [triggerFisiereDomeniu]);

  const deleteDocument = async () => {
    try {
      await deleteDomeniuDocument(locationType.toLowerCase(), folderName, documentToDelete);
      refreshFisiereDomeniu();
      setDocumentToDelete(null);
    } catch (err) {
      setDocumentToDelete(null);
      setError("Eroare la stergerea documentului");
    }
  };

  const handleUploadDocument = async (event) => {
    try {
      const fileToUpload = event.target.files[0];
      if (!fileToUpload) return;

      const formData = new FormData();
      formData.append("file", fileToUpload);
      await uploadDomeniuDocument(formData, locationType.toLowerCase(), folderName);

      event.target.value = "";
      refreshFisiereDomeniu();
    } catch (err) {
      setError("Eroare la atasarea documentelor.");
    }
  };

  const closeModalFolderDomeniuCreate = () => {
    setShowModalFolderDomeniuCreate(false);
  };

  return (
    <Row>
      {documentToDelete != null && (
        <ConfirmActionComponent
          buttonIsPressed={true}
          showButtons={false}
          yesPressAction={deleteDocument}
          noPressAction={() => setDocumentToDelete(null)}
          text={`Esti sigur ca vrei sa stergi documentul?`}
        />
      )}
      <>
        {error && (
          <ModalComponent
            size={error ? "sm" : "md"}
            show={error !== null}
            close={() => setError()}
            body={<h3 style={{ color: "red" }}>{error}</h3>}
          />
        )}
      </>
      <Col md={9}>
        {internet && !serverError ? (
          <>
            <Row className={"mb-3"}>
              <div className="headerWrapper">
                <div className="fisere_in_folder_documente_header" onClick={() => navigate(-1)}>
                  <h2>Documentatii {locationType} - {folderName}</h2>
                </div>
                <div
                  style={{
                    width: "60%",
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <div
                    className="d-inline-block mr-2 locatie_istoric_and_gallery_button"
                    onClick={(e) => chooseDocumentToUpload(e)}
                  >
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUploadDocument}
                      ref={hiddenDocumentInput}
                    />
                    <img
                      src={fileCreateIcon}
                      alt="photos"
                      style={{ maxHeight: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </Row>
            <Row className="middleScreen">
              <Col>
                {documentsNames.length === 0 && responseReceived === true && (
                  <div className="lucrari_not_found">
                    Nu exista documente in folder-ul: {folderName}
                  </div>
                )}

                {documentsNames.map((documentData, index) => (
                  <DocumentDomeniuItem
                    key={index}
                    documentData={documentData}
                    folderName={folderName}
                    locationType={locationType}
                    setDocumentToDelete={setDocumentToDelete}
                  />
                ))}
              </Col>
            </Row>
          </>
        ) : (
          <div className="no_internet_wrapper">
            <Image src={logo_image} />
            <div className="no_internet_text">
              {serverError
                ? `Nu este conexiune la server`
                : `Nu este conexiune la internet`}
            </div>
          </div>
        )}
      </Col>
      <Col
        md={3}
        className="lineRightDashboard"
        style={{ marginRight: "0px", paddingRight: "0px" }}
      >
        <TabsLucrare
          locationType={location?.state?.locationType}
          currentLucrare={currentLucrare}
          activeTab={activeTab}
          setTab={setTab}
          refreshLucrari={refreshLucrari}
          locatieName={location && location.state && location.state.locatieName}
          locatieId={location && location.state && location.state.locatieId}
        />
      </Col>
      <ModalComponent
        size={"md"}
        show={showModalFolderDomeniuCreate}
        close={closeModalFolderDomeniuCreate}
        headingText={"Reminder"}
        body={
          <ModalFolderDomeniuCreate
            locationType={locationType.toLowerCase()}
            closeModal={closeModalFolderDomeniuCreate}
          />
        }
      />
    </Row>
  );
};
export default DocumenteDomeniuViewer;
